import { cn } from "../../lib/utils.js"
import { Avatar, AvatarFallback } from "./avatar.js"
import { toAvatarInitialsFromName } from "./to-avatar-initials-from-name.js"

/**
 * Avatar circular com iniciais derivadas do nome.
 * @param {{ name: string, className?: string, fallbackClassName?: string }} props
 */
export function UserAvatar({ name, className, fallbackClassName }) {
  const initials = toAvatarInitialsFromName(name)

  return (
    <Avatar className={cn("bg-gray-900", className)}>
      <AvatarFallback
        className={cn(
          "flex h-full w-full items-center justify-center rounded-full bg-gray-800 text-xs font-medium uppercase text-white",
          fallbackClassName,
        )}
      >
        {initials}
      </AvatarFallback>
    </Avatar>
  )
}
